import * as ComparativeAnalysisActions from "../actions/comparative-analysis.actions";

const initialState = {
  pageCompTitle: "",
};

export function comparativeAnalysisReducer(state = initialState, action) {
  switch (action.type) {
    case ComparativeAnalysisActions.SET_COMPARATIVE_HEADER_TITLE:
      return {
        ...state,
        pageCompTitle: action.payload,
      };

    default:
      return state;
  }
}
